const VacanciesAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    outlet_village: i.shopping_center?.title,
    vacancy_category_title: i.vacancy?.category?.title,
    company_title: i.company?.name,
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default VacanciesAdapter;
